import { getMessage } from 'util/locale';

// Constants
import { messageIds, messageTypes } from 'constants/values';
import { ShapeType } from 'mapping/leaflet';
import { editZoneTypes } from 'constants/scripts';

// Util
import { logError } from 'api/errors';

// Actions
import { addToast } from 'messages';

export const addInstructionMessage = ({ 
  titleMessageKey,
  testId,
  textMessageKey,
  onCancelClick,
  onDoneClick,
  onDoneCheckStrip,
  isCheckStripsEnabled,
  shapeType
}) => {
  const buttons = [
    {
      text: getMessage('button-text__save'),
      onClick: onDoneClick
    }, {
      text: getMessage('button-text__cancel'),
      className: 'vra-message--toast__action-cancel',
      onClick: onCancelClick
    },
  ];

  if (isCheckStripsEnabled && shapeType !== ShapeType.CIRCLE) {
    buttons.push({
      text: getMessage('button-text__save_check_strips'),
      onClick: onDoneCheckStrip
    });
  }

  return addToast({
    title:    getMessage(titleMessageKey),
    testId,
    text:     getMessage(textMessageKey),
    id:       messageIds.DRAWING_INSTRUCTION,
    messageType: messageTypes.NEUTRAL,
    buttons,
    showDismiss: false
  });
};

export const addSplitStartMessage = ({onCancelClick, onDoneClick}) =>
  addInstructionMessage({
    titleMessageKey: 'button-text__split',
    textMessageKey:'help-text__drawing-split-start',
    onCancelClick,
    onDoneClick
  });

export const addMergeStartMessage = ({onCancelClick, onDoneClick}) =>
  addInstructionMessage({
    titleMessageKey: 'button-text__merge',
    textMessageKey:'help-text__drawing-merge-start',
    onCancelClick,
    onDoneClick
  });

export const addCreateStartMessage = ({
  shapeType,
  onCancelClick,
  onDoneClick,
  onDoneCheckStrip,
  isCheckStripsEnabled
}) => {
  const titleMessageKey = `title-text__drawing-${shapeType}`;
  let textMessageKey;
  switch (shapeType) {
    case ShapeType.CIRCLE: textMessageKey = 'help-text__drawing-pivot-start'; break;
    case ShapeType.SQUARE: textMessageKey = 'help-text__drawing-square-start'; break;
    case ShapeType.POLYGON: textMessageKey = 'help-text__drawing-polygon-start'; break;
    default:
      logError({message:'Unexpected shape type.'});
      return null;
  }
  return addInstructionMessage({
    titleMessageKey,
    testId: editZoneTypes.ADD_ZONE,
    textMessageKey,
    onCancelClick,
    onDoneClick,
    onDoneCheckStrip,
    isCheckStripsEnabled,
    shapeType
  });
};
